import { bool, number, string } from "prop-types";

const picture = {
  id: number,
  name: string.isRequired,
  size: number.isRequired,
  type: string.isRequired,
  url: string.isRequired,
  isHeader: bool,
  isPrimary: bool,
  isPrivate: bool,
};

export default picture;
